<template>
    <v-container class="register">
        <v-form v-model="isValid" ref="form" @submit.prevent="submit">
            <v-row>
                <v-col cols="4">
                    <h1 class="text-center bot-color-blue">
                        Đăng ký thành viên
                    </h1>
                    <bot-upload-images
                        :class="action"
                        ref="botImg"
                        v-model="avatar"
                    />
                    <v-alert v-if="snackbar.visible" :type="snackbar.color">{{
                        snackbar.text
                    }}</v-alert>
                </v-col>
                <v-col cols="8">
                    <div
                        v-if="action === 'adding'"
                        class="register-form-adding"
                    >
                        <bot-spinner v-model="spinner">
                            <fieldset>
                                <legend>Thông tin shop</legend>
                                <v-list-item>
                                    <v-text-field
                                        autofocus
                                        v-model="vAdding.PhoneNumber"
                                        label="Số điện thoại"
                                        type="number"
                                        :rules="[vld.phoneNumber]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-text-field
                                        v-model="vAdding.ConsignorName"
                                        label="Tên shop"
                                        :rules="[
                                            (value) =>
                                                vld.text({
                                                    field: 'tên shop',
                                                    value,
                                                }),
                                        ]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-text-field
                                        v-model="vAdding.MemberName"
                                        label="Tên người liên hệ"
                                        :rules="[
                                            (value) =>
                                                vld.text({
                                                    field: 'tên người liên hệ',
                                                    value,
                                                }),
                                        ]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-text-field
                                        label="Email"
                                        v-model="vAdding.Email"
                                        :rules="[(value) => vld.email(value)]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-radio-group
                                        v-model="vAdding.Gender"
                                        label="Giới tính"
                                        row
                                    >
                                        <v-radio
                                            :value="1"
                                            label="nam"
                                            color="success"
                                        ></v-radio>
                                        <v-radio
                                            :value="2"
                                            label="nữ"
                                            color="red"
                                            class=""
                                        ></v-radio>
                                        <v-radio
                                            :value="0"
                                            label="khác"
                                            color="warning"
                                        ></v-radio>
                                    </v-radio-group>
                                    <v-spacer></v-spacer>
                                    <bot-date-picker
                                        v-model="vAdding.DateOfBirth"
                                        :options="options.DateOfBirth"
                                    ></bot-date-picker>
                                </v-list-item>
                            </fieldset>
                            <div class="text-center">
                                <v-btn
                                    class="ma-2"
                                    color="primary"
                                    @click="submit"
                                >
                                    Đăng ký
                                    <v-icon right> mdi-check </v-icon>
                                </v-btn>
                            </div>
                        </bot-spinner>
                    </div>
                    <div
                        v-if="['activating', 'activated'].includes(action)"
                        class="register-form-activating"
                    >
                        <bot-spinner v-model="spinner">
                            <table class="table">
                                <tr>
                                    <th>Số điện thoại:</th>
                                    <td>{{ vAdding.PhoneNumber }}</td>
                                </tr>
                                <tr>
                                    <th>Tên shop:</th>
                                    <td>{{ vAdding.ConsignorName }}</td>
                                </tr>
                                <tr>
                                    <th>Người liên hệ:</th>
                                    <td>{{ vAdding.MemberName }}</td>
                                </tr>
                                <tr>
                                    <th>Email:</th>
                                    <td>{{ vAdding.Email }}</td>
                                </tr>
                                <tr>
                                    <th>Giới tính:</th>
                                    <td>{{ vAdding.GenderLabel }}</td>
                                </tr>
                                <tr>
                                    <th>Ngày sinh:</th>
                                    <td>{{ vAdding.DateOfBirthLabel }}</td>
                                </tr>
                            </table>
                            <fieldset v-if="action === 'activating'">
                                <legend>
                                    Nhập mã kích hoạt và tạo mật khẩu
                                </legend>
                                <v-list-item>
                                    <v-text-field
                                        autofocus
                                        v-model="vActive.ActiveCode"
                                        label="Mã kích hoạt"
                                        :rules="[
                                            (value) =>
                                                vld.text({
                                                    field: 'mã kích hoạt',
                                                    value,
                                                }),
                                        ]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-text-field
                                        v-model="vActive.Password"
                                        label="Mật khẩu"
                                        type="password"
                                        :rules="[
                                            (value) =>
                                                vld.text({
                                                    field: 'mật khẩu',
                                                    value,
                                                }),
                                        ]"
                                    ></v-text-field>
                                </v-list-item>
                                <v-list-item>
                                    <v-text-field
                                        v-model="vActive.ConfirmPassword"
                                        label="Nhập lại mật khẩu"
                                        type="password"
                                        :rules="[
                                            (value) =>
                                                vld.text({
                                                    field: 'lại mật khẩu',
                                                    value,
                                                }),
                                            (value) =>
                                                (!!value &&
                                                    value ===
                                                        vActive.Password) ||
                                                'Mật khẩu và nhập lại mật khẩu chưa giống nhau!',
                                        ]"
                                    ></v-text-field>
                                </v-list-item>
                            </fieldset>
                            <div
                                class="text-center"
                                v-if="action === 'activating'"
                            >
                                <v-btn
                                    class="ma-2"
                                    color="success"
                                    @click="handleActive"
                                >
                                    <v-icon left> mdi-send </v-icon>
                                    Kích hoạt
                                </v-btn>
                            </div>
                        </bot-spinner>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import moment from "moment";
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
import BotDatePicker from "@/components/bot/datePicker/bot.date.picker.vue";
import BotUploadImages from "@/components/bot/upload/bot.upload.images.vue";

const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            authen: {
                loadActive: "authen/loadActive",
                register: "authen/register",
                activate: "authen/activate",
            },
        },
        member: {
            PhoneNumber: "0909466948",
            ConsignorName: "Vận tải Bắc Nam",
            MemberName: "Văn Trường",
            Email: "vantaibacnam.vn@gmail.com",
            Gender: 1,
        },
    },
    format: {
        date: "YYYY-MM-DD",
        dateTime: "YYYY-MM-DD HH:mm:ss",
    },
    timeout: {
        redirect: 4000,
    },
    sms: {
        imgOnly: "Chỉ cho phép upload ảnh jpg hoặc png!",
        success: {
            register:
                "Đăng ký thành công, bạn hãy kiểm tra email của mình trong ít phút nữa!",
            active: "Cảm ơn bạn, tất cả đã hoàn tất! Hệ thống sẽ chuyển hướng đến trang login!",
            activated: "Bạn đã kích hoạt tài khoản!",
        },
    },
    imgMaxSize: 5 * 1024, //5MB
};
const df = cafe.default;
const dob = (main) => {
    return moment(
        main.$store.state.useragent.headers.time,
        cafe.format.dateTime
    )
        .add(-16, "year")
        .format(cafe.format.date);
};
const isTest = 0;

export default {
    name: "Register",

    components: {
        "bot-spinner": BotSpinner,
        "bot-date-picker": BotDatePicker,
        "bot-upload-images": BotUploadImages,
    },

    // this is state
    data() {
        return {
            isValid: false,
            action: "adding",
            hlog: this.$options.filters.hlog,
            tufl: this.$options.filters.tufl,
            tuflow: this.$options.filters.tuflow,
            vld: this.$options.filters.validate,
            snackbar: {
                visible: false,
                text: "Hello snackbar!",
                color: "warning",
            },
            spinner: {
                visible: false,
                color: "red",
            },
            options: {
                DateOfBirth: {
                    label: "Ngày sinh",
                    max: dob(this), //cấm trẻ em dưới 16t
                },
            },
            vAdding: {
                Avatar: null,
                PhoneNumber: null,
                ConsignorName: null,
                MemberName: null,
                Email: null,
                Gender: 1,
                DateOfBirth: dob(this),
            },
            vActive: {
                ActiveCode: null,
                Password: null,
                ConfirmPassword: null,
            },
        };
    },

    async asyncData({ store }) {
        const dp = store.dispatch;
        await dp(df.sp.authen.loadActive);
    },

    mounted() {
        this.reloadData();
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
        avatar() {
            return {
                src: this.vAdding.Avatar,
                title: this.vAdding.MemberName,
                caption: "Ảnh đại diện",
            };
        },
    },

    methods: {
        async submit() {
            /*********|form validate|*********/
            const { form, botImg } = this.$refs;
            if (!form || !botImg) return;
            this.isValid = form.validate();
            if (!this.isValid) return;

            /*********|config filter|*********/
            console.clear();
            this.spinner.visible = true;
            const dp = this.$store.dispatch;
            let isUpload = !!botImg.file && !botImg.src.indexOf("data:image");
            let { MemberID } = this.vAdding;
            console.log("isUpload", isUpload);

            /*********|update load Avatar file|*********/
            let key = MemberID ? `/profile/${MemberID}` : `/temp`;
            let src = await botImg.handleUpload({ key });
            if (!src) return;
            this.hlog.start("submit", "vAdding", this.vAdding);
            // let IP = await dp("loadIP");
            let {
                PhoneNumber,
                ConsignorName,
                MemberName,
                Email,
                Gender,
                DateOfBirth,
            } = this.vAdding;
            ConsignorName = this.tuflow(ConsignorName);
            MemberName = this.tuflow(MemberName);
            let payload = {
                Avatar: src,
                PhoneNumber,
                ConsignorName,
                MemberName,
                Email,
                Gender,
                DateOfBirth,
            };
            console.log("payload", payload);
            const res_add = await dp(df.sp.authen.register, payload);
            console.log("res_add", res_add);
            if (!res_add.is_success) {
                this.spinner.visible = false;
                this.snackbar = {
                    visible: true,
                    text: res_add.error,
                    color: "error",
                };
                return;
            }
            this.snackbar = {
                visible: true,
                text: cafe.sms.success.register,
                color: "success",
            };
            await dp(df.sp.authen.loadActive);
            this.reloadData();
            this.spinner.visible = false;
        },
        async handleActive() {
            /*********|form validate|*********/
            const { form } = this.$refs;
            if (!form) return;
            this.isValid = form.validate();
            if (!this.isValid) return;

            /*********|config filter|*********/
            console.clear();
            this.spinner.visible = true;
            const { Avatar } = this.vAdding;
            const { ActiveCode, Password } = this.vActive;
            const dp = this.$store.dispatch;
            let payload = { ActiveCode, Password, Avatar };
            this.hlog.start("active", "start", payload);
            const res_active = await dp(df.sp.authen.activate, payload);
            this.hlog.end("active", "end", res_active);
            if (!res_active.is_success) {
                this.spinner.visible = false;
                this.snackbar = {
                    visible: true,
                    text: res_active.error,
                    color: "error",
                };
                return;
            }
            this.snackbar = {
                visible: true,
                text: cafe.sms.success.active,
                color: "success",
            };
            setTimeout(() => {
                window.location.href = "/authen/login";
            }, cafe.timeout.redirect);
        },
        reloadData() {
            if (isTest) this.vAdding = Object.assign(this.vAdding, df.member);
            const { temp } = this.$store.state.authen;
            this.hlog.start("page", "start", temp);
            let keys = Object.keys(temp);
            if (keys.length <= 0) return;
            let GenderLabel = "nam";
            let DateOfBirthLabel = moment(temp.DateOfBirth);
            DateOfBirthLabel = DateOfBirthLabel.format(cafe.format.date);
            if (temp.Gender === 2) GenderLabel = "nữ";
            if (temp.Gender === 0) GenderLabel = "khác";
            let obj01 = Object.assign({}, temp);
            let obj02 = { GenderLabel, DateOfBirthLabel };
            this.vAdding = Object.assign(obj01, obj02);
            if (temp.MemberID) {
                this.action = "activated";
                this.snackbar = {
                    visible: true,
                    text: cafe.sms.success.activated,
                    color: "success",
                };
            } else this.action = "activating";
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.container.register {
    width: 60%;
}

.container.register, .register .register-form-activating, .register .register-form-adding {
    position: relative;
}

::v-deep .bot-upload-images.activating .v-image, ::v-deep .bot-upload-images.activated .v-image {
    pointer-events: none;
    cursor: default;
}

fieldset {
    border-width: 1px;
    padding: 20px;
}

fieldset:not(:first-child) {
    margin-top: 25px;
}

fieldset legend {
    padding: 0 12px;
    font-family: 'Roboto-Bold';
}

.register table.table {
    width: 100%;
    font-size: 16px;
    border: 1px solid gray;
    border-spacing: 2px;
    border-color: grey;
    border-collapse: collapse;
}

.register table.table tr th, .register table.table tr td {
    padding: 16px;
}

.register table.table tr th {
    text-align: right;
}

.register table.table tr:not(:last-child) td {
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

::v-deep .v-text-field>.v-input__control>.v-input__slot:before {
    border-style: dashed;
}
</style>



// WEBPACK FOOTER //
// register.vue